// extracted by mini-css-extract-plugin
export var bubble = "_31-0";
export var container = "_31-f";
export var contrastBorder = "_31-g";
export var greyOut = "_31-2";
export var initialsColor0 = "_31-3";
export var initialsColor1 = "_31-4";
export var initialsColor10 = "_31-d";
export var initialsColor11 = "_31-e";
export var initialsColor2 = "_31-5";
export var initialsColor3 = "_31-6";
export var initialsColor4 = "_31-7";
export var initialsColor5 = "_31-8";
export var initialsColor6 = "_31-9";
export var initialsColor7 = "_31-a";
export var initialsColor8 = "_31-b";
export var initialsColor9 = "_31-c";
export var initialsWrapper = "_31-1";
export var large = "_31-l";
export var medium = "_31-k";
export var mediumSmall = "_31-j";
export var mediumSmallMedium = "_31-o";
export var micro = "_31-h";
export var small = "_31-i";
export var tiny = "_31-n";
export var xTiny = "_31-m";